module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-check-fill-3db5f77a.svg";